.ux-radio-list-item {
  background-color: $color-white;
  display: block;

  &:hover {
    background-color: $color-gray-10;
  }

  .ux-radio-button-field {
    display: block;
  }

  .ux-radio-button {
    width: 100%;
  }

  .ux-radio-button__input:focus-visible + .ux-radio-button__label {
    border: solid 1px var(--ux-button-focus-border-color);
  }

  .ux-radio-button__label {
    @include font(light);

    color: $color-gray-text;
    font-size: $size-text-medium;
    margin: 0;
    padding: 10px;
    text-transform: none;
  }

  &--active {
    .ux-radio-button__label {
      color: $color-black;
    }
  }

  .ux-radio-button__label::before,
  .ux-radio-button__label::after {
    display: none;
  }
}
